import { StrictMode } from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import ReactDOM from 'react-dom/client'
import { ConfigProvider, theme as antdTheme } from 'antd'
import ptBR from 'antd/lib/locale/pt_BR'
import App from './App'
import { colors } from './theme'

// `darkAlgorithm` e o que veste TODO o Ant Design de escuro de uma vez —
// Select, Table, Modal, DatePicker, Tooltip, Segmented, Tabs, Popover. Sem ele
// seria preciso sobrescrever componente a componente, e o projeto nao tem
// nenhum override `.ant-*` para se apoiar.
// Os tokens abaixo continuam necessarios: o algoritmo escurece o chrome do
// AntD, mas nao sabe qual e a cor da marca. `colorBgBase`/`colorBgContainer`
// prendem o fundo dos componentes a mesma superficie dos styled-components,
// senao o cinza-azulado do AntD destoa dos cards da tela.
// So cor: a fonte segue vindo do GlobalStyle, para nao alterar a metrica das
// tabelas densas (GestaoTenants, PredictAnalytics, MensagensEnviadas).
const temaAntd = {
  algorithm: antdTheme.darkAlgorithm,
  token: {
    colorPrimary: colors.secondary,
    colorSuccess: colors.secondary,
    colorError: colors.error,
    colorLink: colors.secondaryText,
    colorBgBase: colors.grey100,
    colorBgContainer: colors.surface,
    colorBgElevated: colors.surfaceHigh,
    colorBorder: colors.grey300,
    // ⚠️ So o token BASE de texto. `colorText`/`colorTextSecondary` sao
    // DERIVADOS: o AntD calcula a partir daqui a escala inteira (texto normal,
    // secundario, terciario, placeholder, desabilitado) com opacidades
    // coerentes entre si. Fixando os derivados na mao, a escala quebra — foi o
    // que aconteceu: o valor escolhido num Select saia mais apagado que as
    // opcoes da propria lista, e o placeholder saia branco puro, igual ao
    // valor preenchido.
    colorTextBase: colors.grey900,
  },
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <StrictMode>
    <ConfigProvider locale={ptBR} theme={temaAntd}>
      <App />
    </ConfigProvider>
  </StrictMode>
)
